<div class="e-tech-support" role="region">
    <div>
        <h3>Technical Support</h3>
        <p>{{ supportMessage }}</p>
    </div>
    <div class="e-support-contact" *ngFor="let techSupport of techSupportData">
        <img src="/assets/images/placeholder/placeholder.png" aria-hidden="true" />
        <h4>{{ techSupport.title }}</h4>
        <p>
            <span>{{ techSupport.region }} Support</span><br />
            {{ techSupport.phone }}<br />
            {{ techSupport.location }}
        </p>
    </div>
</div>
